import React, { useCallback } from 'react';
import {
  SafeAreaView,
  ScrollView,
  StatusBar,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import HelpSVG from '~/credsystem/assets/svgs/help-settings.svg';
import AboutSVG from '~/credsystem/assets/svgs/circle-warning.svg';
import CloseSVG from '~/assets/svgs/close.svg';
import colors from '~/assets/themes/colors';
import MarisaLogoSVG from '~/credsystem/assets/svgs/marisa-logo.svg';
import useAppNavigation from '~/hooks/useAppNavigation';
import useCredsystemDataStore from '~/credsystem/stores/credsystemData';
import { getEndCardNumber, stringToCapitalCase } from '~/utils/string';
import MenuButton from './components/MenuButton';
import useCredsystemAuthStore from '~/credsystem/stores/credsystemAuth';
import initCredsystemUser from '~/credsystem/hooks/initCredsystemUser';

const Separator = () => {
  return <View className="h-[1px] w-full bg-primary-400" />;
};

const Settings: React.FC = () => {
  const isFocused = useIsFocused();
  const { goBack, navigate } = useAppNavigation();
  const { firstName, cardNumber, clearCardInfo } = useCredsystemDataStore(
    (state) => ({
      firstName: state.credsystemCardInfo?.holder,
      cardNumber: state.credsystemCardInfo?.cardNumber,
      clearCardInfo: state.clear,
    })
  );
  const logoutUser = useCredsystemAuthStore((state) => state.logout);

  const logout = useCallback(async () => {
    clearCardInfo();
    await logoutUser();
    initCredsystemUser();
    navigate('MarisaServicos_Home');
  }, [clearCardInfo, logoutUser, navigate]);

  return (
    <SafeAreaView className="flex-1 bg-primary-600 container max-w-5xl  mx-auto">
      <View className="flex-1 bg-primary-600 p-4">
        {isFocused && (
          <StatusBar
            animated={true}
            backgroundColor={colors.primary[600]}
            barStyle={'light-content'}
          />
        )}
        <ScrollView
          contentContainerStyle={{ flexGrow: 1, paddingBottom: 40 }}
          showsVerticalScrollIndicator={false}
          alwaysBounceVertical={false}
          className="flex-1 pt-4 pb-6"
        >
          <View>
            <View className="justify-between flex-row mb-3 items-center">
              <MarisaLogoSVG />
              <TouchableOpacity onPress={goBack}>
                <CloseSVG
                  className="self-center"
                  height={24}
                  width={24}
                  color={colors.light[100]}
                />
              </TouchableOpacity>
            </View>
            <View className="justify-center items-center">
              <Text className="text-[20px] text-light-100">
                {' '}
                {firstName
                  ? `Oi, ${stringToCapitalCase(firstName.split(' ')[0])}! `
                  : 'Oi! '}
              </Text>
              <Text className="text-sm text-light-100">
                Cartão Final {` `}
                {getEndCardNumber(cardNumber)}
              </Text>
            </View>
          </View>
          <View className="flex-1 mt-10">
            <MenuButton
              icon={HelpSVG}
              label="Preciso de Ajuda"
              onPress={() => navigate('Credsystem_SAC')}
            />
            <Separator />
            <MenuButton
              icon={AboutSVG}
              label="Sobre a Credsystem"
              onPress={() => navigate('Credsystem_About')}
            />
          </View>
        </ScrollView>

        <TouchableOpacity
          className="border-[1px] border-light-100 w-full rounded-lg bg-primary-600 py-4"
          onPress={logout}
        >
          <Text className="text-light-100 text-sm text-center">
            SAIR DA CONTA
          </Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

export default Settings;
